import C from "./constants";
import initialState from "./initialState"

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case C.SET_EXPANDED_DETAILS: {
      return {...state, ...action.payload};
    }
    default: {
      return state;
    }
  }
}
